import * as React from 'react'
// libs
import { Helmet } from 'react-helmet-async'
// components
import RegistersFilter from 'components/UI/PageSearch/filters/RegistersFilter'
import ObjectivesTable from './components/Table'
import MainLayoutContainer from 'containers/MainLayout/index'
import NavigationSidebar from 'components/UI/NavigationSidebar'
import Search from 'components/UI/PageSearch'
// context
import { ObjectivesPageContext } from 'containers/Objectives/Register/layers/API'
// themes
import { LayoutContainerInnerWrapper } from 'themes/views/layouts'

const Objectives: React.FC = () => {
  const { config, isLoading, pageFilter } = React.useContext(ObjectivesPageContext)

  return (
    <>
      <Helmet>
        <title>Skefto - {pageFilter || 'Objectives'}</title>
      </Helmet>
      <MainLayoutContainer isLoading={isLoading} CTA={<Search filter={RegistersFilter} />}>
        <NavigationSidebar config={config} />
        <LayoutContainerInnerWrapper>
          <ObjectivesTable />
        </LayoutContainerInnerWrapper>
      </MainLayoutContainer>
    </>
  )
}

export default Objectives
